/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'

import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'

import ReviewerProfile from '../reviewing/ReviewerProfile'
import ReviewerItemCard from './helpers/items/ReviewerItemCard'
import ProfileToReviewItem from './helpers/items/ProfileToReviewItem'
import ReviewerSelectedItem from './helpers/items/ReviewerSelectedItem'

import { fullReviewerProfileModalJSX } from './helpers/modals/fullReviewerProfileModalJSX'
import { submitSuccessfulJSX } from './helpers/jsx/submitSuccessfulJSX'
import { selectReviewTypeJSX } from './helpers/jsx/selectReviewType'
import { addFriendReviewersJSX } from './helpers/jsx/addFriendReviewersJSX'
import { selectReviewerListJSX } from './helpers/jsx/selectReviewerListJSX'
import { summaryJSX } from './helpers/jsx/summaryJSX'
import { paymentDetailsJSX } from './helpers/jsx/paymentDetailsJSX'

import useWindowDimensions from '../../helpers/windowDimensions'
import { getPayload, userIsAuthenticated, getTokenFromLocalStorage } from '../../helpers/storage'
import { seoPageTags } from '../../helpers/analytics'
import { standardSpinner } from '../../helpers/spinners'
import { standardButton, exitModalIconButton } from '../../helpers/buttons'
import { navbarHeight, dashboardNavbarHeight, footerHeight, positionChangeWidthSm, reviewTypeOptionsArray, aiReviewRate, aiReviewDiscount, expertReviewRate, expertReviewDiscount, friendReviewRate, friendReviewDiscount, swipelyticsTurquoise, showPayments } from '../../helpers/variableDefaults'
import { advisoryTypography } from '../../helpers/typographies'
import { standardErrorContainer } from '../../helpers/errors'
import { dummyBoxWidth, handleChange, noDuplicatesInArray, validEmail, capitalizeFirstLetter, isInstagramOrFacebook, handleOpenInBrowser } from '../../helpers/globalHelpers'
import { standardInfoTooltip } from '../../helpers/tooltips'
import { newFriendReviewerTextField } from '../../helpers/textfields'

// Stripe
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'

// Request Feedback Page
const RequestFeedback = (props) => {

  const { stripePaymentForm, setStripePaymentForm, isDemo, demoUser, profileType } = props

  // Stripe
  const stripe = useStripe()
  const elements = useElements()
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()
  
  // Navigate
  const navigate = useNavigate()

  // Params
  const { userId, datingProfileId } = useParams()

  // Payload
  const payload = getPayload()

  // States
  const [user, setUser] = useState({})
  const [datingProfile, setDatingProfile] = useState({})
  const [selectedReviewerProfile, setSelectedReviewerProfile] = useState({})
  const [reviewerProfileToView, setReviewerProfileToView] = useState({})
  const [reviewerProfiles, setReviewerProfiles] = useState([])
  const [selectedReviewType, setSelectedReviewType] = useState({
    ...reviewTypeOptionsArray[0],
  })
  const [friendReviewersArray, setFriendReviewersArray] = useState([
    {
      firstName: ``,
      email: ``,
    }
  ])
  const [allFriendReviewersAdded, setAllFriendReviewersAdded] = useState(false)

  const [openFullReviewerProfileModal, setOpenFullReviewerProfileModal] = useState(false)

  const [requestSubmitSuccessful, setRequestSubmitSuccessful] = useState(false)

  // Loading
  const [loading, setLoading] = useState(false)
  const [loadingPayment, setLoadingPayment] = useState(false)
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  // Errors
  const [errors, setErrors] = useState(false)
  const [paymentErrors, setPaymentErrors] = useState({ })
  const [errorsSubmit, setErrorsSubmit] = useState(false)
  const [newFriendErrors, setNewFriendErrors] = useState(false)

  // Show Payments — For programming, toggle on/off payment accepting or not
  // const [showStripePayments, setShowStripePayments] = useState(showPayments)
  const [paymentMethodString, setPaymentMethodString] = useState('card')

  useEffect(() => {
    if (isDemo) {
      setUser({ ...demoUser })

      setDatingProfile(demoUser.datingProfiles.filter((profile, index) => profile.type.toLowerCase() === profileType.toLowerCase())[0])

      setReviewerProfiles([ ...demoUser.reviewerProfilesToSelectFrom ])

    } else if (!userIsAuthenticated() || !userId) {
      navigate(`/login`)
    } else if (userId !== payload.sub) {
      navigate(`/dashboard/${payload.sub}`)
      // reloadView()
    } else {
      const fetchData = async () => {
        setLoading(true)
        
        try {
          const { data: retrievedUser } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/users/${payload.sub}/request-review`, {
            headers: {
              Authorization: `Bearer ${getTokenFromLocalStorage()}`,
            },
          })

          // console.log('retrievedUser ->', retrievedUser)

          if (
            retrievedUser._id === payload.sub
            && 'datingProfiles' in retrievedUser
            && retrievedUser.datingProfiles.length > 0
            && retrievedUser.datingProfiles.filter((profile, index) => profile._id === datingProfileId).length > 0
          ) {
            
            // Set User State
            setUser(retrievedUser)

            // console.log('dating profile ->', retrievedUser.datingProfiles.filter((profile, index) => profile._id === datingProfileId)[0])
            setDatingProfile(retrievedUser.datingProfiles.filter((profile, index) => profile._id === datingProfileId)[0])

            if ('reviewerProfilesToSelectFrom' in retrievedUser && retrievedUser.reviewerProfilesToSelectFrom.length > 0) {
              setReviewerProfiles(retrievedUser.reviewerProfilesToSelectFrom)
            }

            // Update Stripe Payment Form
            setStripePaymentForm({
              ...stripePaymentForm,
              // amount: aiReviewRate * 100,
              // currency: 'usd',
              // mode: 'payment',
              cardholderName: 'bio' in retrievedUser && 'vitalInfo' in retrievedUser.bio && 'firstName' in retrievedUser.bio.vitalInfo && retrievedUser.bio.vitalInfo.firstName.length > 0 ? retrievedUser.bio.vitalInfo.firstName : '',
              promoCode: '',
              paymentMethodIsValid: false,
            })

            setLoading(false)

          } else {
            useNavigate(`/dashboard/${payload.sub}`)
            setLoading(false)
          }

        } catch (err) {
          // console.log(err)

          navigate('/')
          setLoading(false)
        }
      }
  
      fetchData()
    }

  }, [])

  useEffect(() => {
    // console.log('useEffect Runs')

  }, [selectedReviewerProfile, openFullReviewerProfileModal, requestSubmitSuccessful, allFriendReviewersAdded, friendReviewersArray])



  const allFriendReviewerInfoAdded = () => {
    return friendReviewersArray.filter(friend => (friend.firstName.trim().length <= 0 || !validEmail(friend.email))).length === 0 && noDuplicatesInArray(friendReviewersArray.map(friend => friend.email))
  }

  const friendProceedToPaymentButtonDisabled = () => {
    return !(friendReviewersArray.length > 0 && allFriendReviewerInfoAdded())
  }


  // When 'Add Another Friend' is pressed
  const handleAddFriend = async (e) => {
    e.preventDefault()

    setFriendReviewersArray([
      ...friendReviewersArray,
      {
        firstName: ``,
        email: ``,
      }
    ])
  }

  const removeFriend = async (e, index) => {
    e.preventDefault()
    const newFriends = [ ...friendReviewersArray ]
    newFriends.splice(index, 1)
    setFriendReviewersArray([ ...newFriends ])

  }

  const handleFriendProceedToPaymentPressed = () => {

    setStripePaymentForm({ ...stripePaymentForm, amount: selectedReviewType.price * friendReviewersArray.length * 100 > 0 ? selectedReviewType.price * friendReviewersArray.length * 100 : 500 })
    setAllFriendReviewersAdded(true)
  } 

  const handleBackToSelectReviewer = () => {
    console.log('handleBackToSelectReviewer runs')

    // setStripePaymentForm({ ...stripePaymentForm, amount: reviewTypeOptionsArray[0].price * 100 })
    // setSelectedReviewType({
    //   ...reviewTypeOptionsArray[0],
    // })
    setAllFriendReviewersAdded(false)
    setSelectedReviewerProfile({})
  }
  
  const handleBackToDashboard = () => {
    console.log('handleBackToDashboard runs')
    // console.log('datingProfile.type ->', capitalizeFirstLetter(datingProfile.type))

    navigate(`/dashboard/${userId}`, { state: { previousProfileType: capitalizeFirstLetter(datingProfile.type) } })
  }

  const handleSelectReviewType = (e, reviewTypeItem) => {
    e.preventDefault()
    console.log('handleSelectReviewType runs')
    // console.log('reviewTypeItem ->', reviewTypeItem) 

    setSelectedReviewerProfile({})
    setStripePaymentForm({ ...stripePaymentForm, amount: reviewTypeItem.price * 100 > 0 ? reviewTypeItem.price * 100 : 500 })
    // setSelectedReviewType({ type: reviewTypeItem.type, price: reviewTypeItem.price })
    setSelectedReviewType({ ...reviewTypeItem })
  }

  // When credit card info is all added, switch paymentMethodIsValid to true
  const handlePaymentElementChange = (e) => {
    // console.log('handlePaymentElementChange runs')
    // console.log('handlePaymentElementChange event ->', e)

    // setPaymentErrors({ message: 'testing' })
    setPaymentErrors({ })

    if ('value' in e && 'type' in e.value && e.value.type !== paymentMethodString) {
      
      setPaymentMethodString(e.value.type)
    }

    if (e.complete !== stripePaymentForm.paymentMethodIsValid) {

      setStripePaymentForm({ ...stripePaymentForm, paymentMethodIsValid: e.complete })

    } 
  }

  const handleSubmitRequestPressed = async () => {
    console.log('handleSubmitRequestPressed runs')

    if (isDemo) {
      console.log('demo')
      if (
        !isInstagramOrFacebook()
        // || isInstagramOrFacebook()
      ) {
        navigate('/create-account')
      } else {
        navigate('/create-account')
        // handleOpenInBrowser('create-account')
      }
    } else {
      // console.log('datingProfile ->', datingProfile)
      // console.log('datingProfile.media ->', datingProfile.media)
      // console.log('datingProfile.bio ->', datingProfile.bio)
      // console.log('datingProfile.bio.prompts ->', datingProfile.bio.prompts)
      const mediaFeedbackToUpload = Array.from({ length: datingProfile.media.length },(v,k)=> { 
        return { feedback: '', verdict: '' }
      })

      const promptsFeedbackToUpload = 'prompts' in datingProfile.bio && datingProfile.bio.prompts.length > 0 ? Array.from({ length: datingProfile.bio.prompts.length },(v,k)=> { 
        return { feedback: '', verdict: '' }
      })
        :
        []

      const newProfileReviewsArray = []

      const objectToUpload = { 
        userId: userId,
        userEmail: user.email,
        datingProfileId: datingProfileId,
        // reviewerProfileId: selectedReviewType.type === 'Friend' ? 123456789 : selectedReviewerProfile._id,
        reviewerEmail: selectedReviewType.type === 'Friend' ? friendReviewersArray[0].email : selectedReviewerProfile.email,
        reviewerFirstName: selectedReviewType.type === 'Friend' ? capitalizeFirstLetter(friendReviewersArray[0].firstName.trim().split(/\s(.+)/)[0].toLowerCase()) : selectedReviewerProfile.bio.vitalInfo.firstName,
        isFriendReview: selectedReviewType.type === 'Friend' ? true : false,
        isAIReview: selectedReviewType.type === 'AI' ? true : false,
        // nameOfLLM: selectedReviewType.type === 'Expert' || selectedReviewType.type === 'Friend' ? 'NA' : 'ChatGPT',
        priceOfReview: selectedReviewType.price,
        type: datingProfile.type,
        // vibes: datingProfile.vibes,
        media: datingProfile.media,
        mediaFeedback: mediaFeedbackToUpload,
        bio: datingProfile.bio,
        bioFeedback: {
          vitalInfoFeedback: { feedback: '', verdict: '' },
          aboutMeFeedback: { feedback: '', verdict: '' },
          promptsFeedback: promptsFeedbackToUpload,
        },
        generalFeedback: {
          vibe: '',
          good: '',
          notGood: '',
          verdict: '',
        },
      }

      if (selectedReviewType.type === 'Friend') {
        for (let i = 0; i < friendReviewersArray.length; i++) {
          const friendReviewerObjToUpload = { 
            ...objectToUpload,
            reviewerEmail: friendReviewersArray[i].email,
            reviewerFirstName: capitalizeFirstLetter(friendReviewersArray[i].firstName.trim().split(/\s(.+)/)[0].toLowerCase()),
          }
          newProfileReviewsArray.push(friendReviewerObjToUpload)
        }
      } else {
        const nonFriendReviewerObjToUpload = {
          ...objectToUpload,
          reviewerProfileId: selectedReviewerProfile._id,
        }
        newProfileReviewsArray.push(nonFriendReviewerObjToUpload)
      }
      // console.log('objectToUpload ->', objectToUpload)

      if (selectedReviewType.price < 1 || (!stripePaymentForm.paymentMethodIsValid && !showPayments)) {
        console.log('No payment processing but add review')

        try {
          setLoadingSubmit(true)
          setErrorsSubmit(false)

          // await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/profile-reviews/`, objectToUpload, {
          await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/profile-reviews/`, newProfileReviewsArray, {
            headers: {
              Authorization: `Bearer ${getTokenFromLocalStorage()}`,
            },
          })

          setRequestSubmitSuccessful(true)

          // Update States
          setErrorsSubmit(false)
          setLoadingSubmit(false)
          // setPaymentErrors({})
          setLoadingPayment(false)
          
        } catch (profileReviewUploadError) {
          console.log('Profile Review UploadError ->', profileReviewUploadError)

          // Update States
          setErrorsSubmit(true)
          setLoadingSubmit(false)
          // setPaymentErrors({})
          setLoadingPayment(false)
        }
      } else {
        // Payment processed before uploading review

        setLoadingPayment(true)

        try {
          setLoadingSubmit(true)
          setErrorsSubmit(false)

          // Handle Payment
          // Stripe — Trigger form validation and wallet collection
          const { error: submitError } = await elements.submit()
          if (submitError) {
            // setRegisterErrors(false)
            setPaymentErrors(submitError)
            setLoadingPayment(false)
            return
          }
          // const cardholderNameToUpload = 
          //   'cardholderName' in stripePaymentForm && stripePaymentForm.cardholderName.length > 0 && stripePaymentForm.cardholderName !== 'NA'
          //   ?
          //   stripePaymentForm.cardholderName
          //   :
          //   'bio' in user && 'vitalInfo' in user.bio && 'firstName' in user.bio.vitalInfo && user.bio.vitalInfo.firstName.length > 0 
          //     ? 
          //     user.bio.vitalInfo.firstName 
          //     : 
          //     'NA'
          // const formToUpload = { ...stripePaymentForm, cardholderName: cardholderNameToUpload }
          const formToUpload = { ...stripePaymentForm }

          try {
            const { data } = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/create-payment-intent/`, formToUpload, {
              headers: {
                Authorization: `Bearer ${getTokenFromLocalStorage()}`,
              },
            })
            // console.log('data ->', data)
            // console.log('data.clientSecret ->', data.clientSecret)
            // console.log('data.customerId ->', data.customerId)

            const clientSecret = data.clientSecret
            const customerId = data.customerId
            // console.log('elements ->', elements)
            // console.log('cardElement ->', cardElement)
            // console.log('stripe ->', stripe)
      
            const { error: confirmPaymentError } = await stripe.confirmPayment({
              elements,
              clientSecret,
              confirmParams: {
                return_url: `${process.env.REACT_APP_CLIENT_URL}/`,
              },
              redirect: 'if_required',
            })
            // console.log('confirmPaymentError ->', confirmPaymentError)

            if (confirmPaymentError) {
              console.log('confirm payment error')

              setErrorsSubmit(false)
              setPaymentErrors(confirmPaymentError)
              setLoadingPayment(false)
              setLoadingSubmit(false)
            } else {
              console.log('everything runs successfully, now you can add a Profile Review')
              
              // Create the Profile Review Here
              // objectToUpload.stripeCustomerId = customerId
              for (let i = 0; i < newProfileReviewsArray.length; i++) {
                newProfileReviewsArray[i].stripeCustomerId = customerId
              }
              // objectToUpload.subscriptionIsActive = true

              try {
                // await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/profile-reviews/`, objectToUpload, {
                await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/profile-reviews/`, newProfileReviewsArray, {
                  headers: {
                    Authorization: `Bearer ${getTokenFromLocalStorage()}`,
                  },
                })

                setRequestSubmitSuccessful(true)

                // Update States
                setErrorsSubmit(false)
                setLoadingSubmit(false)
                setPaymentErrors({})
                setLoadingPayment(false)
                
              } catch (profileReviewUploadError) {
                console.log('Profile Review UploadError ->', profileReviewUploadError)

                // Update States
                setErrorsSubmit(true)
                setLoadingSubmit(false)
                setPaymentErrors({})
                setLoadingPayment(false)
              }
            }


          } catch (paymentIntentError) {
            console.log('Payment Intent Error ->', paymentIntentError)
            setErrorsSubmit(false)
            setLoadingSubmit(false)
            setPaymentErrors({ message: 'Payment Processing Errors' })
            setLoadingPayment(false)
          }

        } catch (err) {
          console.log('submit review request error ->', err)

          setLoadingPayment(false)
          setPaymentErrors({ message: 'Payment Method Errors' })
          setErrorsSubmit(false)
          setLoadingSubmit(false)
        }
      }
    }
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        'Request Feedback'
      )}

      {/* Body */}
      {loading ?
        <Box sx={{ 
          width: '100%',
          // minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
          minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
          mt: 0, mb: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        }}>
          {standardSpinner()}
        </Box>
        : 
        requestSubmitSuccessful 
          ?
          submitSuccessfulJSX(selectedReviewType, handleBackToDashboard)
          :
          <Box 
            sx={{ 
              width: '100%',
              minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
            }}
          >
            <Box sx={{ mt: 4, mb: 4, width: '100%', maxWidth: '900px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

              {(selectedReviewType.type !== 'Friend' && (selectedReviewerProfile === null || Object.keys(selectedReviewerProfile).length === 0)) 
              || ( selectedReviewType.type === 'Friend' && !allFriendReviewersAdded)
                ?
                <>
                  {/* Review Type */}
                  {selectReviewTypeJSX(selectedReviewType, handleSelectReviewType, width)}

                  {/* Friend Reviewer Details */}
                  {'type' in selectedReviewType && selectedReviewType.type.length > 0 && selectedReviewType.type === 'Friend' && !allFriendReviewersAdded &&
                    addFriendReviewersJSX(friendReviewersArray, setFriendReviewersArray, removeFriend, handleAddFriend, allFriendReviewerInfoAdded, friendProceedToPaymentButtonDisabled, handleFriendProceedToPaymentPressed, newFriendErrors, setNewFriendErrors, width)
                  }

                  {/* AI and Expert Reviewer Lists */}
                  {'type' in selectedReviewType && selectedReviewType.type.length > 0 && selectedReviewType.type !== 'Friend' &&
                    selectReviewerListJSX(isDemo, reviewerProfiles, selectedReviewType, setSelectedReviewerProfile, setReviewerProfileToView, setOpenFullReviewerProfileModal, stripePaymentForm, setStripePaymentForm, width)
                  }
                </>
                :
                <Box
                  sx={{
                    width: '95%',
                    maxWidth: '600px',
                    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                  }}
                >
                  {/* Back to Select Reviewer Button */}
                  {standardButton(
                    selectedReviewType.type === 'Friend' ? 'Back to Select Reviewer' : 'Back to Select Reviewer', 
                    'button',
                    'text',
                    loadingPayment || loadingSubmit,
                    'secondary', 
                    1,
                    2,
                    0,
                    width > 300 ? '220px' : '45%', 
                    '45px', 
                    handleBackToSelectReviewer
                  )}

                  {/* Client Profile */}
                  <Box
                    sx={{
                      my: 1,
                      p: 2,
                      backgroundColor: 'whitesmoke',
                      width: '100%',
                      boxShadow: 3,
                      borderRadius: '5px',
                      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                    }}
                  >
                    {/* Title  */}
                    <Typography
                      sx={{
                        fontWeight: 'bold',
                        fontSize: '18',
                      }}
                    >
                      Profile to Review
                    </Typography>

                    {/* Profile (Lead Image; Name, Type) */}
                    <ProfileToReviewItem profile={datingProfile} user={user} />

                  </Box>


                  {/* Reviewer */}
                  <Box
                    sx={{
                      my: 1,
                      p: 2,
                      backgroundColor: 'whitesmoke',
                      width: '100%',
                      boxShadow: 3,
                      borderRadius: '5px',
                      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                    }}
                  >

                    {/* Title, Advisory  */}
                    <Typography
                      sx={{
                        fontWeight: 'bold',
                        fontSize: '18',
                      }}
                    >
                      {selectedReviewType.type === 'Friend' && friendReviewersArray.length > 1 ? `Reviewers` : `Reviewer`}
                    </Typography>

                    {/* Reviewer (Lead Image; Name, Age, About Me) */}
                    {selectedReviewType.type !== 'Friend' 
                      ? 
                      <ReviewerSelectedItem profile={selectedReviewerProfile} user={user} />
                      :
                      <Box
                        sx={{
                          // my: 2,
                          width: '100%',
                          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
                        }}
                      >
                        {friendReviewersArray.map((friendReviewer, friendReviewerIndex) => (
                          <Box
                            key={friendReviewerIndex}
                            sx={{
                              my: 1,
                              px: 1,
                              width: '100%',
                              display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start',
                            }}
                          >
                            <span style={{ fontWeight: 'bold', marginRight: '5px' }}>{friendReviewer.firstName}</span> — {friendReviewer.email}
                          </Box>
                        ))}
                      </Box>
                    }
                  </Box>


                  {/* Summary */}
                  {selectedReviewType.type.length > 0 &&
                    summaryJSX(selectedReviewType, friendReviewersArray, selectedReviewerProfile)
                  }


                  {/* Payment Details */}
                  {showPayments && !isDemo && selectedReviewType.price > 0 &&
                    paymentDetailsJSX(PaymentElement, paymentMethodString, handlePaymentElementChange, stripePaymentForm, setStripePaymentForm, paymentErrors, setPaymentErrors, loadingPayment)
                  }


                  {/* Submit Request Button */}
                  {!loadingPayment &&
                    <Box
                      sx={{
                        my: 1,
                        width: '100%',
                        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                      }}
                    >
                      {standardButton(
                        'Submit', 
                        'button',
                        'contained',
                        (!isDemo && (!(stripePaymentForm.paymentMethodIsValid) && showPayments && selectedReviewType.price > 0) || loadingSubmit || selectedReviewType.type.length === 0),
                        // loadingSubmit || selectedReviewType.type.length === 0,
                        'primary', 
                        1,
                        0,
                        0,
                        width > 300 ? '220px' : '95%', 
                        '45px', 
                        handleSubmitRequestPressed
                      )}

                      {/* Advisory */}
                      {!loadingPayment 
                        && (paymentMethodString === 'card') 
                        && (paymentMethodString !== 'card') 
                        &&
                        <Typography 
                          component='pre'
                          textAlign={'center'}
                          sx={{
                            mb: 0, mt: 1,
                            width: '90%',
                            fontStyle: 'italic',
                            color: 'blue',
                          }}
                        >
                          {
                            `*Card will be charged immediately`.replace(/ {4} +/g, '')
                          }
                        </Typography>
                      }

                      {/* Advisory */}
                      {!loadingPayment 
                        // && (paymentMethodString === 'card') 
                        &&
                        <Typography 
                          component='pre'
                          textAlign={'center'}
                          sx={{
                            mt: 1, mb: 2,
                            width: '90%',
                            fontStyle: 'italic',
                            color: 'blue',
                          }}
                        >
                          
                          {`*Payments processed through Stripe`.replace(/ {4} +/g, '')}
                            
                        </Typography>
                      }
                    </Box>
                  }

                  {loadingSubmit && 
                    advisoryTypography(`Uploading Review Request...`)
                  }

                  {errorsSubmit && 
                    standardErrorContainer(
                      `There was an error with your request. Check your Internet connection and try again`,
                      0,
                      0
                    )
                  }
                </Box>
              
              }

            </Box>

            {/* Feedback Info Modal */}
            {openFullReviewerProfileModal && reviewerProfileToView !== null && Object.keys(reviewerProfileToView).length > 0 &&
              fullReviewerProfileModalJSX(isDemo, demoUser, profileType, reviewerProfileToView, setReviewerProfileToView, openFullReviewerProfileModal, setOpenFullReviewerProfileModal, width)
            }
          </Box>
      }
    </>
  )
}

export default RequestFeedback